import { Route, Routes } from 'react-router-dom';
import { SectionNavBarButtonOptions } from '../../atoms/SectionNavButton.types';
import ApproachAvoid from './ApproachAvoid';
import { GameApproachAvoidData } from '../Games.types';

type Properties = {
    data: GameApproachAvoidData;
    setNavBarLeftButton: (options: SectionNavBarButtonOptions | undefined) => void;
    setNavBarRightButton: (options: SectionNavBarButtonOptions | undefined) => void;
};

const ApproachAvoidRouter = (props: Properties) => {
    const { data, setNavBarLeftButton, setNavBarRightButton } = props;

    return <Routes>
        <Route 
            path="" 
            element={<ApproachAvoid
                data={data}
                setNavBarLeftButton={setNavBarLeftButton}
                setNavBarRightButton={setNavBarRightButton}
            />}
        />
        <Route 
            path=":step" 
            element={<ApproachAvoid
                data={data}
                setNavBarLeftButton={setNavBarLeftButton}
                setNavBarRightButton={setNavBarRightButton}
            />}
        />
    </Routes>;
};

export default ApproachAvoidRouter;
